import React, { FC } from 'react';
import classNames from 'classnames';
import { ProductThumbnailUnderbar } from '@app/react/uikit';
import { PartsProduct } from '@app/react/const/type';

export interface FamilycrestListProps {
    className?: string;
    selectable?: boolean;
    value: PartsProduct | null;
    items: Array<PartsProduct>;
    onClick?: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        product: PartsProduct
    ) => void;
}

export const FamilycrestList: FC<FamilycrestListProps> = ({
    className,
    selectable = true,
    value,
    items,
    onClick = () => false,
}) => (
    <div className={classNames('familycrest-list', className)}>
        {items.map((item) => (
            <ProductThumbnailUnderbar
                key={item.id}
                className={classNames('familycrest-item', {
                    nonselectable: !selectable,
                })}
                product={item}
                onClick={onClick}
                checked={selectable ? value?.id === item.id : false}
            />
        ))}
    </div>
);
